import { createContext, useContext, useReducer } from 'react';
import { Pagination } from '../../../model/paginatiion';
import { ACTION_TYPES, NewsReducer, NewsState } from './news-reducer';

const NewsContext = createContext<NewsState | undefined>(undefined);
const NewsContextDispatchContext = createContext({} as any);

const NewsProvider = ({ children }: { children: React.ReactNode }) => {
    const initialState: NewsState = {
        news: new Pagination(),
        categories: [],
        loading: false,
        loadingFilters: false,
    };

    const [state, dispatch] = useReducer(NewsReducer, initialState);

    return (
        <NewsContext.Provider value={state}>
            <NewsContextDispatchContext.Provider value={dispatch}>
                {children}
            </NewsContextDispatchContext.Provider>
        </NewsContext.Provider>
    );
}

const useNewsState = () => {
    const context = useContext(NewsContext);
    if (context === undefined) {
        throw new Error('useNewsState must be used within a NewsProvider');
    }
    return context;
}

const useNewsDispatch = () => {
    const context = useContext(NewsContextDispatchContext);
    if (context === undefined) {
        throw new Error('useNewsDispatch must be used within a NewsProvider');
    }
    return context;
}

export { NewsProvider, useNewsState, useNewsDispatch, ACTION_TYPES };
